// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Qy","articleImagesWrap":"Ry","articleImage":"Sy","singleImage":"Ty"};